// Downloads block schema - Featured downloadable file showcase
export const downloadsSchema = {
  type: 'downloads',
  label: 'Downloads',
  description: 'Showcase a downloadable file with optional email gate',
  icon: 'Download',
  defaultContent: {
    title: '',
    description: '',
    buttonText: 'Download',
    coverImage: '',
    fileUrl: '',
    fileName: '',
    fileSize: 0,
    fileType: '',
    requireEmail: false,
    layout: 'imageLeft',
    style: {},
  },
};
